import React from 'react'

const CategoriesPage = () => {
  return <div>CategoriesPage</div>
}

export default CategoriesPage
